<script setup lang="ts">
import { computed } from "vue";
import { formatTimeago } from "../lib/useTimeago";
import { useRfpPhases } from "../lib/useRfp";

const props = defineProps<{
  rfpId?: string;
  proposalShortlisted: boolean;
}>();

const today = new Date();
const reactiveRfpId = computed(() => props.rfpId);
const {
  rfpOpenDate,
  firstRoundOpenDate,
  firstRoundDeadline,
  shortlistDeadline,
} = useRfpPhases(reactiveRfpId);
const rfpOpenDateTimeago = computed(() =>
  rfpOpenDate.value ? formatTimeago(rfpOpenDate.value) : null,
);
const firstRoundOpenDateTimeago = computed(() =>
  firstRoundOpenDate.value ? formatTimeago(firstRoundOpenDate.value) : null,
);
const firstRoundDeadlineTimeago = computed(() =>
  firstRoundDeadline.value ? formatTimeago(firstRoundDeadline.value) : null,
);
const shortlistDeadlineTimeago = computed(() =>
  shortlistDeadline.value ? formatTimeago(shortlistDeadline.value) : null,
);

const displayProperties = computed<{
  color: "yellow" | "gray";
  icon: string;
  text: string;
} | null>(() => {
  if (rfpOpenDate.value && today < rfpOpenDate.value && rfpOpenDateTimeago) {
    return {
      color: "yellow",
      icon: "schedule",
      text: `Open ${rfpOpenDateTimeago.value}`,
    };
  } else if (
    firstRoundOpenDate.value &&
    today < firstRoundOpenDate.value &&
    firstRoundOpenDateTimeago
  ) {
    return {
      color: "yellow",
      icon: "schedule",
      text: `Accepting proposals ${firstRoundOpenDateTimeago.value}`,
    };
  } else if (
    firstRoundDeadline.value &&
    today < firstRoundDeadline.value &&
    firstRoundDeadlineTimeago.value
  ) {
    return {
      color: "yellow",
      icon: "schedule",
      text: `Closes ${firstRoundDeadlineTimeago.value}`,
    };
  } else if (
    (!props.proposalShortlisted || !shortlistDeadline.value) &&
    firstRoundDeadline.value &&
    today > firstRoundDeadline.value &&
    firstRoundDeadlineTimeago.value
  ) {
    return {
      color: "gray",
      icon: "event_busy",
      text: `Closed ${firstRoundDeadlineTimeago.value}`,
    };
  } else if (
    shortlistDeadline.value &&
    today < shortlistDeadline.value &&
    shortlistDeadlineTimeago
  ) {
    return {
      color: "yellow",
      icon: "schedule",
      text: `Shortlist closes ${shortlistDeadlineTimeago.value}`,
    };
  } else if (shortlistDeadline.value && firstRoundDeadlineTimeago) {
    return {
      color: "gray",
      icon: "event_busy",
      text: `Shortlist closed ${firstRoundDeadlineTimeago.value}`,
    };
  }
  return null;
});
</script>
<template>
  <TFadeInTransition>
    <t-chip
      dense
      outlined
      :color="displayProperties.color"
      v-if="displayProperties"
    >
      <t-icon small left>{{ displayProperties.icon }}</t-icon>
      {{ displayProperties.text }}
    </t-chip>
  </TFadeInTransition>
</template>
